// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteEndpointsDeleteEnrollmentTokenData, DeleteEndpointsDeleteEnrollmentTokenResponses, DeleteEndpointsDeleteSupportSessionData, DeleteEndpointsDeleteSupportSessionResponses, DeleteEndpointsRemoveData, DeleteEndpointsRemoveResponses, DeleteNetworkDiscoveryDeleteNetworkPolicyData, DeleteNetworkDiscoveryDeleteNetworkPolicyResponses, DeleteNetworkDiscoveryDeleteOrganizationPolicyData, DeleteNetworkDiscoveryDeleteOrganizationPolicyResponses, DeleteOrganizationsDeleteData, DeleteOrganizationsDeleteResponses, DeleteRmmCryptoRevokeCapabilityData, DeleteRmmCryptoRevokeCapabilityResponses, DeleteScriptsDeleteCategoryData, DeleteScriptsDeleteCategoryResponses, DeleteScriptsRemoveData, DeleteScriptsRemoveResponses, DeleteTagsDeleteData, DeleteTagsDeleteResponses, DeleteTechniciansRemoveData, DeleteTechniciansRemoveResponses, DeleteUpgradesCancelData, DeleteUpgradesCancelResponses, GetAccessCheckData, GetAccessCheckResponses, GetAgentVersionsLatestData, GetAgentVersionsLatestResponses, GetBridgeHealthStartupData, GetBridgeHealthStartupResponses, GetEndpointsGetConnectionsData, GetEndpointsGetConnectionsResponses, GetEndpointsGetData, GetEndpointsGetHardwareData, GetEndpointsGetHardwareResponses, GetEndpointsGetMonitoringCapabilitiesData, GetEndpointsGetMonitoringCapabilitiesResponses, GetEndpointsGetMonitoringPolicyData, GetEndpointsGetMonitoringPolicyResponses, GetEndpointsGetProgramsData, GetEndpointsGetProgramsResponses, GetEndpointsGetResponses, GetEndpointsGetSmartHistoryData, GetEndpointsGetSmartHistoryResponses, GetEndpointsGetUserSessionsData, GetEndpointsGetUserSessionsResponses, GetEndpointsListData, GetEndpointsListEnrollmentTokensData, GetEndpointsListEnrollmentTokensResponses, GetEndpointsListMonitoringAlertsData, GetEndpointsListMonitoringAlertsResponses, GetEndpointsListResponses, GetEndpointsListSupportSessionsData, GetEndpointsListSupportSessionsResponses, GetEndpointsTrustPolicyData, GetEndpointsTrustPolicyResponses, GetNetworkDiscoveryFindEndpointsData, GetNetworkDiscoveryFindEndpointsResponses, GetNetworkDiscoveryFindNetworksData, GetNetworkDiscoveryFindNetworksResponses, GetNetworkDiscoveryGetNetworkPolicyData, GetNetworkDiscoveryGetNetworkPolicyResponses, GetNetworkDiscoveryGetNetworkScanNodeData, GetNetworkDiscoveryGetNetworkScanNodeResponses, GetNetworkDiscoveryGetPolicyData, GetNetworkDiscoveryGetPolicyResponses, GetNetworkDiscoveryListDevicesData, GetNetworkDiscoveryListDevicesResponses, GetNetworkDiscoveryListNetworksData, GetNetworkDiscoveryListNetworksResponses, GetOrganizationsListData, GetOrganizationsListResponses, GetRmmCryptoAuthoritiesData, GetRmmCryptoAuthoritiesResponses, GetRmmCryptoCapabilityData, GetRmmCryptoCapabilityPolicyData, GetRmmCryptoCapabilityPolicyResponses, GetRmmCryptoCapabilityResponses, GetRmmCryptoLegacyCredentialMigrationData, GetRmmCryptoLegacyCredentialMigrationResponses, GetRmmCryptoRecoveryData, GetRmmCryptoRecoveryResponses, GetRmmCryptoStatusData, GetRmmCryptoStatusResponses, GetScriptsGetData, GetScriptsGetResponses, GetScriptsListCategoriesData, GetScriptsListCategoriesResponses, GetScriptsListData, GetScriptsListResponses, GetShareGrantsGetShareGrantData, GetShareGrantsGetShareGrantResponses, GetTagsListData, GetTagsListResponses, GetTechniciansListData, GetTechniciansListResponses, GetTechniciansRenewalCandidatesData, GetTechniciansRenewalCandidatesResponses, GetUpgradesGetData, GetUpgradesGetResponses, GetUpgradesListData, GetUpgradesListExecutionsData, GetUpgradesListExecutionsResponses, GetUpgradesListResponses, PostAgentVersionsPublishedData, PostAgentVersionsPublishedResponses, PostEndpointsAcknowledgeMonitoringAlertData, PostEndpointsAcknowledgeMonitoringAlertResponses, PostEndpointsCreateEnrollmentTokenData, PostEndpointsCreateEnrollmentTokenResponses, PostEndpointsCreateSupportSessionData, PostEndpointsCreateSupportSessionResponses, PostEndpointsDismissMonitoringAlertData, PostEndpointsDismissMonitoringAlertResponses, PostOrganizationsCreateData, PostOrganizationsCreateResponses, PostRmmCryptoFinalizeLegacyCutoverData, PostRmmCryptoFinalizeLegacyCutoverResponses, PostRmmCryptoGrantAuthoritiesData, PostRmmCryptoGrantAuthoritiesResponses, PostRmmCryptoInitializeData, PostRmmCryptoInitializeResponses, PostRmmCryptoIssueCapabilityData, PostRmmCryptoIssueCapabilityForAccountData, PostRmmCryptoIssueCapabilityForAccountResponses, PostRmmCryptoIssueCapabilityResponses, PostRmmCryptoIssueOwnCapabilityData, PostRmmCryptoIssueOwnCapabilityResponses, PostScriptsCreateCategoryData, PostScriptsCreateCategoryResponses, PostScriptsPublishData, PostScriptsPublishResponses, PostScriptsRevokeData, PostScriptsRevokeResponses, PostTagsCreateData, PostTagsCreateResponses, PostTechniciansCreateSrpcTokenData, PostTechniciansCreateSrpcTokenResponses, PostTechniciansCredentialReadyData, PostTechniciansCredentialReadyResponses, PostTechniciansRequestEnrollmentData, PostTechniciansRequestEnrollmentResponses, PostUpgradesQueueData, PostUpgradesQueueResponses, PostZynoRpcDispatchData, PostZynoRpcDispatchResponses, PutEndpointsRenameEnrollmentTokenData, PutEndpointsRenameEnrollmentTokenResponses, PutEndpointsUpdateData, PutEndpointsUpdateMonitoringPolicyData, PutEndpointsUpdateMonitoringPolicyResponses, PutEndpointsUpdatePlacementData, PutEndpointsUpdatePlacementResponses, PutEndpointsUpdateResponses, PutEndpointsUpdateTrustPolicyData, PutEndpointsUpdateTrustPolicyResponses, PutNetworkDiscoveryPutNetworkPolicyData, PutNetworkDiscoveryPutNetworkPolicyResponses, PutNetworkDiscoveryPutNetworkScanNodeData, PutNetworkDiscoveryPutNetworkScanNodeResponses, PutNetworkDiscoveryPutPolicyData, PutNetworkDiscoveryPutPolicyResponses, PutNetworkDiscoveryUpdateNetworkData, PutNetworkDiscoveryUpdateNetworkResponses, PutOrganizationsUpdateData, PutOrganizationsUpdateResponses, PutRmmCryptoReplaceCapabilityData, PutRmmCryptoReplaceCapabilityResponses, PutRmmCryptoStoreAuthoritiesData, PutRmmCryptoStoreAuthoritiesResponses, PutRmmCryptoUpdateCapabilityPolicyData, PutRmmCryptoUpdateCapabilityPolicyResponses, PutScriptsUpdateData, PutScriptsUpdateResponses, PutTagsUpdateData, PutTagsUpdateResponses, PutTechniciansUpdateData, PutTechniciansUpdateResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export class RmmAgentVersionsApi {
    public static getAgentVersionsLatest<ThrowOnError extends boolean = false>(options?: Options<GetAgentVersionsLatestData, ThrowOnError>): RequestResult<GetAgentVersionsLatestResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetAgentVersionsLatestResponses, unknown, ThrowOnError>({ url: '/agent-versions/latest', ...options });
    }
    
    /**
     * CI calls this only after the matching R2 manifest and every immutable artifact have been externally verified. A changed manifest immediately notifies connected technicians to refetch their authorized view.
     */
    public static postAgentVersionsPublished<ThrowOnError extends boolean = false>(options: Options<PostAgentVersionsPublishedData, ThrowOnError>): RequestResult<PostAgentVersionsPublishedResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostAgentVersionsPublishedResponses, unknown, ThrowOnError>({
            url: '/agent-versions/published/{channel}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class RmmAccessApi {
    public static getAccessCheck<ThrowOnError extends boolean = false>(options?: Options<GetAccessCheckData, ThrowOnError>): RequestResult<GetAccessCheckResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetAccessCheckResponses, unknown, ThrowOnError>({ url: '/access', ...options });
    }
}

export class RmmBridgeHealthApi {
    public static getBridgeHealthStartup<ThrowOnError extends boolean = false>(options?: Options<GetBridgeHealthStartupData, ThrowOnError>): RequestResult<GetBridgeHealthStartupResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetBridgeHealthStartupResponses, unknown, ThrowOnError>({ url: '/startupz', ...options });
    }
}

export class RmmEndpointsApi {
    public static getEndpointsList<ThrowOnError extends boolean = false>(options?: Options<GetEndpointsListData, ThrowOnError>): RequestResult<GetEndpointsListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetEndpointsListResponses, unknown, ThrowOnError>({ url: '/endpoints', ...options });
    }
    
    public static getEndpointsListEnrollmentTokens<ThrowOnError extends boolean = false>(options?: Options<GetEndpointsListEnrollmentTokensData, ThrowOnError>): RequestResult<GetEndpointsListEnrollmentTokensResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetEndpointsListEnrollmentTokensResponses, unknown, ThrowOnError>({ url: '/endpoints/enrollment-tokens', ...options });
    }
    
    public static postEndpointsCreateEnrollmentToken<ThrowOnError extends boolean = false>(options: Options<PostEndpointsCreateEnrollmentTokenData, ThrowOnError>): RequestResult<PostEndpointsCreateEnrollmentTokenResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostEndpointsCreateEnrollmentTokenResponses, unknown, ThrowOnError>({
            url: '/endpoints/enrollment-tokens',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteEndpointsDeleteEnrollmentToken<ThrowOnError extends boolean = false>(options: Options<DeleteEndpointsDeleteEnrollmentTokenData, ThrowOnError>): RequestResult<DeleteEndpointsDeleteEnrollmentTokenResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteEndpointsDeleteEnrollmentTokenResponses, unknown, ThrowOnError>({ url: '/endpoints/enrollment-tokens/{token}', ...options });
    }
    
    public static putEndpointsRenameEnrollmentToken<ThrowOnError extends boolean = false>(options: Options<PutEndpointsRenameEnrollmentTokenData, ThrowOnError>): RequestResult<PutEndpointsRenameEnrollmentTokenResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutEndpointsRenameEnrollmentTokenResponses, unknown, ThrowOnError>({
            url: '/endpoints/enrollment-tokens/{token}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getEndpointsListSupportSessions<ThrowOnError extends boolean = false>(options?: Options<GetEndpointsListSupportSessionsData, ThrowOnError>): RequestResult<GetEndpointsListSupportSessionsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetEndpointsListSupportSessionsResponses, unknown, ThrowOnError>({ url: '/endpoints/support-sessions', ...options });
    }
    
    public static postEndpointsCreateSupportSession<ThrowOnError extends boolean = false>(options: Options<PostEndpointsCreateSupportSessionData, ThrowOnError>): RequestResult<PostEndpointsCreateSupportSessionResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostEndpointsCreateSupportSessionResponses, unknown, ThrowOnError>({
            url: '/endpoints/support-sessions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteEndpointsDeleteSupportSession<ThrowOnError extends boolean = false>(options: Options<DeleteEndpointsDeleteSupportSessionData, ThrowOnError>): RequestResult<DeleteEndpointsDeleteSupportSessionResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteEndpointsDeleteSupportSessionResponses, unknown, ThrowOnError>({ url: '/endpoints/support-sessions/{agentId}', ...options });
    }
    
    public static deleteEndpointsRemove<ThrowOnError extends boolean = false>(options: Options<DeleteEndpointsRemoveData, ThrowOnError>): RequestResult<DeleteEndpointsRemoveResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteEndpointsRemoveResponses, unknown, ThrowOnError>({ url: '/endpoints/{agentId}', ...options });
    }
    
    public static getEndpointsGet<ThrowOnError extends boolean = false>(options: Options<GetEndpointsGetData, ThrowOnError>): RequestResult<GetEndpointsGetResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetEndpointsGetResponses, unknown, ThrowOnError>({ url: '/endpoints/{agentId}', ...options });
    }
    
    public static putEndpointsUpdate<ThrowOnError extends boolean = false>(options: Options<PutEndpointsUpdateData, ThrowOnError>): RequestResult<PutEndpointsUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutEndpointsUpdateResponses, unknown, ThrowOnError>({
            url: '/endpoints/{agentId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getEndpointsGetMonitoringPolicy<ThrowOnError extends boolean = false>(options: Options<GetEndpointsGetMonitoringPolicyData, ThrowOnError>): RequestResult<GetEndpointsGetMonitoringPolicyResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetEndpointsGetMonitoringPolicyResponses, unknown, ThrowOnError>({ url: '/endpoints/{agentId}/monitoring-policy', ...options });
    }
    
    public static putEndpointsUpdateMonitoringPolicy<ThrowOnError extends boolean = false>(options: Options<PutEndpointsUpdateMonitoringPolicyData, ThrowOnError>): RequestResult<PutEndpointsUpdateMonitoringPolicyResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutEndpointsUpdateMonitoringPolicyResponses, unknown, ThrowOnError>({
            url: '/endpoints/{agentId}/monitoring-policy',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getEndpointsGetMonitoringCapabilities<ThrowOnError extends boolean = false>(options: Options<GetEndpointsGetMonitoringCapabilitiesData, ThrowOnError>): RequestResult<GetEndpointsGetMonitoringCapabilitiesResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetEndpointsGetMonitoringCapabilitiesResponses, unknown, ThrowOnError>({ url: '/endpoints/{agentId}/monitoring-capabilities', ...options });
    }
    
    public static getEndpointsGetSmartHistory<ThrowOnError extends boolean = false>(options: Options<GetEndpointsGetSmartHistoryData, ThrowOnError>): RequestResult<GetEndpointsGetSmartHistoryResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetEndpointsGetSmartHistoryResponses, unknown, ThrowOnError>({ url: '/endpoints/{agentId}/smart/{deviceStableId}/history', ...options });
    }
    
    public static getEndpointsListMonitoringAlerts<ThrowOnError extends boolean = false>(options: Options<GetEndpointsListMonitoringAlertsData, ThrowOnError>): RequestResult<GetEndpointsListMonitoringAlertsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetEndpointsListMonitoringAlertsResponses, unknown, ThrowOnError>({ url: '/endpoints/{agentId}/alerts', ...options });
    }
    
    public static postEndpointsAcknowledgeMonitoringAlert<ThrowOnError extends boolean = false>(options: Options<PostEndpointsAcknowledgeMonitoringAlertData, ThrowOnError>): RequestResult<PostEndpointsAcknowledgeMonitoringAlertResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostEndpointsAcknowledgeMonitoringAlertResponses, unknown, ThrowOnError>({
            url: '/endpoints/{agentId}/alerts/{alertId}/acknowledge',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postEndpointsDismissMonitoringAlert<ThrowOnError extends boolean = false>(options: Options<PostEndpointsDismissMonitoringAlertData, ThrowOnError>): RequestResult<PostEndpointsDismissMonitoringAlertResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostEndpointsDismissMonitoringAlertResponses, unknown, ThrowOnError>({
            url: '/endpoints/{agentId}/alerts/{alertId}/dismiss',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getEndpointsGetHardware<ThrowOnError extends boolean = false>(options: Options<GetEndpointsGetHardwareData, ThrowOnError>): RequestResult<GetEndpointsGetHardwareResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetEndpointsGetHardwareResponses, unknown, ThrowOnError>({ url: '/endpoints/{agentId}/hardware', ...options });
    }
    
    public static getEndpointsGetPrograms<ThrowOnError extends boolean = false>(options: Options<GetEndpointsGetProgramsData, ThrowOnError>): RequestResult<GetEndpointsGetProgramsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetEndpointsGetProgramsResponses, unknown, ThrowOnError>({ url: '/endpoints/{agentId}/programs', ...options });
    }
    
    public static getEndpointsGetConnections<ThrowOnError extends boolean = false>(options: Options<GetEndpointsGetConnectionsData, ThrowOnError>): RequestResult<GetEndpointsGetConnectionsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetEndpointsGetConnectionsResponses, unknown, ThrowOnError>({ url: '/endpoints/{agentId}/connections', ...options });
    }
    
    public static getEndpointsGetUserSessions<ThrowOnError extends boolean = false>(options: Options<GetEndpointsGetUserSessionsData, ThrowOnError>): RequestResult<GetEndpointsGetUserSessionsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetEndpointsGetUserSessionsResponses, unknown, ThrowOnError>({ url: '/endpoints/{agentId}/user-sessions', ...options });
    }
    
    public static getEndpointsTrustPolicy<ThrowOnError extends boolean = false>(options: Options<GetEndpointsTrustPolicyData, ThrowOnError>): RequestResult<GetEndpointsTrustPolicyResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetEndpointsTrustPolicyResponses, unknown, ThrowOnError>({ url: '/endpoints/{agentId}/trust-policy', ...options });
    }
    
    public static putEndpointsUpdateTrustPolicy<ThrowOnError extends boolean = false>(options: Options<PutEndpointsUpdateTrustPolicyData, ThrowOnError>): RequestResult<PutEndpointsUpdateTrustPolicyResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutEndpointsUpdateTrustPolicyResponses, unknown, ThrowOnError>({
            url: '/endpoints/{agentId}/trust-policy',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static putEndpointsUpdatePlacement<ThrowOnError extends boolean = false>(options: Options<PutEndpointsUpdatePlacementData, ThrowOnError>): RequestResult<PutEndpointsUpdatePlacementResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutEndpointsUpdatePlacementResponses, unknown, ThrowOnError>({
            url: '/endpoints/{agentId}/placement',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class RmmNetworkDiscoveryApi {
    /**
     * Remove an organization override and resume inheritance from tenant policy.
     */
    public static deleteNetworkDiscoveryDeleteOrganizationPolicy<ThrowOnError extends boolean = false>(options?: Options<DeleteNetworkDiscoveryDeleteOrganizationPolicyData, ThrowOnError>): RequestResult<DeleteNetworkDiscoveryDeleteOrganizationPolicyResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).delete<DeleteNetworkDiscoveryDeleteOrganizationPolicyResponses, unknown, ThrowOnError>({ url: '/network-discovery/policy', ...options });
    }
    
    public static getNetworkDiscoveryGetPolicy<ThrowOnError extends boolean = false>(options?: Options<GetNetworkDiscoveryGetPolicyData, ThrowOnError>): RequestResult<GetNetworkDiscoveryGetPolicyResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetNetworkDiscoveryGetPolicyResponses, unknown, ThrowOnError>({ url: '/network-discovery/policy', ...options });
    }
    
    public static putNetworkDiscoveryPutPolicy<ThrowOnError extends boolean = false>(options: Options<PutNetworkDiscoveryPutPolicyData, ThrowOnError>): RequestResult<PutNetworkDiscoveryPutPolicyResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutNetworkDiscoveryPutPolicyResponses, unknown, ThrowOnError>({
            url: '/network-discovery/policy',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getNetworkDiscoveryListNetworks<ThrowOnError extends boolean = false>(options?: Options<GetNetworkDiscoveryListNetworksData, ThrowOnError>): RequestResult<GetNetworkDiscoveryListNetworksResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetNetworkDiscoveryListNetworksResponses, unknown, ThrowOnError>({ url: '/network-discovery/networks', ...options });
    }
    
    /**
     * Removes a network override and resumes the organization/tenant setting.
     */
    public static deleteNetworkDiscoveryDeleteNetworkPolicy<ThrowOnError extends boolean = false>(options: Options<DeleteNetworkDiscoveryDeleteNetworkPolicyData, ThrowOnError>): RequestResult<DeleteNetworkDiscoveryDeleteNetworkPolicyResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteNetworkDiscoveryDeleteNetworkPolicyResponses, unknown, ThrowOnError>({ url: '/network-discovery/networks/{networkId}/policy', ...options });
    }
    
    /**
     * Gets the per-network enabled override or the effective parent value.
     */
    public static getNetworkDiscoveryGetNetworkPolicy<ThrowOnError extends boolean = false>(options: Options<GetNetworkDiscoveryGetNetworkPolicyData, ThrowOnError>): RequestResult<GetNetworkDiscoveryGetNetworkPolicyResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetNetworkDiscoveryGetNetworkPolicyResponses, unknown, ThrowOnError>({ url: '/network-discovery/networks/{networkId}/policy', ...options });
    }
    
    /**
     * Enables or disables this one network, overriding its org/tenant parent.
     */
    public static putNetworkDiscoveryPutNetworkPolicy<ThrowOnError extends boolean = false>(options: Options<PutNetworkDiscoveryPutNetworkPolicyData, ThrowOnError>): RequestResult<PutNetworkDiscoveryPutNetworkPolicyResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutNetworkDiscoveryPutNetworkPolicyResponses, unknown, ThrowOnError>({
            url: '/network-discovery/networks/{networkId}/policy',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Sets or clears the account-managed display name for a discovered network.
     */
    public static putNetworkDiscoveryUpdateNetwork<ThrowOnError extends boolean = false>(options: Options<PutNetworkDiscoveryUpdateNetworkData, ThrowOnError>): RequestResult<PutNetworkDiscoveryUpdateNetworkResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutNetworkDiscoveryUpdateNetworkResponses, unknown, ThrowOnError>({
            url: '/network-discovery/networks/{networkId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getNetworkDiscoveryListDevices<ThrowOnError extends boolean = false>(options: Options<GetNetworkDiscoveryListDevicesData, ThrowOnError>): RequestResult<GetNetworkDiscoveryListDevicesResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetNetworkDiscoveryListDevicesResponses, unknown, ThrowOnError>({ url: '/network-discovery/networks/{networkId}/devices', ...options });
    }
    
    /**
     * Gets whether the bridge may choose one endpoint as a scan node.
     */
    public static getNetworkDiscoveryGetNetworkScanNode<ThrowOnError extends boolean = false>(options: Options<GetNetworkDiscoveryGetNetworkScanNodeData, ThrowOnError>): RequestResult<GetNetworkDiscoveryGetNetworkScanNodeResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetNetworkDiscoveryGetNetworkScanNodeResponses, unknown, ThrowOnError>({ url: '/network-discovery/agents/{agentId}/scan-node', ...options });
    }
    
    /**
     * Includes or excludes an endpoint from bridge-selected network scans.
     */
    public static putNetworkDiscoveryPutNetworkScanNode<ThrowOnError extends boolean = false>(options: Options<PutNetworkDiscoveryPutNetworkScanNodeData, ThrowOnError>): RequestResult<PutNetworkDiscoveryPutNetworkScanNodeResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutNetworkDiscoveryPutNetworkScanNodeResponses, unknown, ThrowOnError>({
            url: '/network-discovery/agents/{agentId}/scan-node',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Resolves discovered network IDs from observed public/WAN and LAN addressing. The WAN address corroborates that an attached endpoint is currently reachable through the same egress address.
     */
    public static getNetworkDiscoveryFindNetworks<ThrowOnError extends boolean = false>(options?: Options<GetNetworkDiscoveryFindNetworksData, ThrowOnError>): RequestResult<GetNetworkDiscoveryFindNetworksResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetNetworkDiscoveryFindNetworksResponses, unknown, ThrowOnError>({ url: '/network-discovery/networks/lookup', ...options });
    }
    
    /**
     * Lists active managed endpoints attached to one discovered network.
     */
    public static getNetworkDiscoveryFindEndpoints<ThrowOnError extends boolean = false>(options?: Options<GetNetworkDiscoveryFindEndpointsData, ThrowOnError>): RequestResult<GetNetworkDiscoveryFindEndpointsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetNetworkDiscoveryFindEndpointsResponses, unknown, ThrowOnError>({ url: '/network-discovery/endpoints', ...options });
    }
}

export class RmmOrganizationsApi {
    public static getOrganizationsList<ThrowOnError extends boolean = false>(options?: Options<GetOrganizationsListData, ThrowOnError>): RequestResult<GetOrganizationsListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetOrganizationsListResponses, unknown, ThrowOnError>({ url: '/organizations', ...options });
    }
    
    public static postOrganizationsCreate<ThrowOnError extends boolean = false>(options: Options<PostOrganizationsCreateData, ThrowOnError>): RequestResult<PostOrganizationsCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostOrganizationsCreateResponses, unknown, ThrowOnError>({
            url: '/organizations',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteOrganizationsDelete<ThrowOnError extends boolean = false>(options: Options<DeleteOrganizationsDeleteData, ThrowOnError>): RequestResult<DeleteOrganizationsDeleteResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteOrganizationsDeleteResponses, unknown, ThrowOnError>({ url: '/organizations/{organizationId}', ...options });
    }
    
    public static putOrganizationsUpdate<ThrowOnError extends boolean = false>(options: Options<PutOrganizationsUpdateData, ThrowOnError>): RequestResult<PutOrganizationsUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutOrganizationsUpdateResponses, unknown, ThrowOnError>({
            url: '/organizations/{organizationId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class RmmRmmCryptoApi {
    public static getRmmCryptoStatus<ThrowOnError extends boolean = false>(options?: Options<GetRmmCryptoStatusData, ThrowOnError>): RequestResult<GetRmmCryptoStatusResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetRmmCryptoStatusResponses, unknown, ThrowOnError>({ url: '/security', ...options });
    }
    
    public static postRmmCryptoInitialize<ThrowOnError extends boolean = false>(options: Options<PostRmmCryptoInitializeData, ThrowOnError>): RequestResult<PostRmmCryptoInitializeResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostRmmCryptoInitializeResponses, unknown, ThrowOnError>({
            url: '/security',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getRmmCryptoRecovery<ThrowOnError extends boolean = false>(options?: Options<GetRmmCryptoRecoveryData, ThrowOnError>): RequestResult<GetRmmCryptoRecoveryResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetRmmCryptoRecoveryResponses, unknown, ThrowOnError>({ url: '/security/recovery', ...options });
    }
    
    public static getRmmCryptoLegacyCredentialMigration<ThrowOnError extends boolean = false>(options: Options<GetRmmCryptoLegacyCredentialMigrationData, ThrowOnError>): RequestResult<GetRmmCryptoLegacyCredentialMigrationResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetRmmCryptoLegacyCredentialMigrationResponses, unknown, ThrowOnError>({ url: '/security/legacy-cutover/credentials/{credentialId}', ...options });
    }
    
    public static postRmmCryptoFinalizeLegacyCutover<ThrowOnError extends boolean = false>(options?: Options<PostRmmCryptoFinalizeLegacyCutoverData, ThrowOnError>): RequestResult<PostRmmCryptoFinalizeLegacyCutoverResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<PostRmmCryptoFinalizeLegacyCutoverResponses, unknown, ThrowOnError>({ url: '/security/legacy-cutover/finalize', ...options });
    }
    
    public static getRmmCryptoAuthorities<ThrowOnError extends boolean = false>(options: Options<GetRmmCryptoAuthoritiesData, ThrowOnError>): RequestResult<GetRmmCryptoAuthoritiesResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetRmmCryptoAuthoritiesResponses, unknown, ThrowOnError>({ url: '/security/authorities/{credentialId}', ...options });
    }
    
    public static putRmmCryptoStoreAuthorities<ThrowOnError extends boolean = false>(options: Options<PutRmmCryptoStoreAuthoritiesData, ThrowOnError>): RequestResult<PutRmmCryptoStoreAuthoritiesResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutRmmCryptoStoreAuthoritiesResponses, unknown, ThrowOnError>({
            url: '/security/authorities/{credentialId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postRmmCryptoGrantAuthorities<ThrowOnError extends boolean = false>(options: Options<PostRmmCryptoGrantAuthoritiesData, ThrowOnError>): RequestResult<PostRmmCryptoGrantAuthoritiesResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostRmmCryptoGrantAuthoritiesResponses, unknown, ThrowOnError>({
            url: '/security/authority-grants',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getRmmCryptoCapability<ThrowOnError extends boolean = false>(options?: Options<GetRmmCryptoCapabilityData, ThrowOnError>): RequestResult<GetRmmCryptoCapabilityResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetRmmCryptoCapabilityResponses, unknown, ThrowOnError>({ url: '/security/capability', ...options });
    }
    
    public static postRmmCryptoIssueOwnCapability<ThrowOnError extends boolean = false>(options: Options<PostRmmCryptoIssueOwnCapabilityData, ThrowOnError>): RequestResult<PostRmmCryptoIssueOwnCapabilityResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostRmmCryptoIssueOwnCapabilityResponses, unknown, ThrowOnError>({
            url: '/security/capability',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteRmmCryptoRevokeCapability<ThrowOnError extends boolean = false>(options: Options<DeleteRmmCryptoRevokeCapabilityData, ThrowOnError>): RequestResult<DeleteRmmCryptoRevokeCapabilityResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteRmmCryptoRevokeCapabilityResponses, unknown, ThrowOnError>({ url: '/security/capabilities/{technicianId}', ...options });
    }
    
    public static postRmmCryptoIssueCapability<ThrowOnError extends boolean = false>(options: Options<PostRmmCryptoIssueCapabilityData, ThrowOnError>): RequestResult<PostRmmCryptoIssueCapabilityResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostRmmCryptoIssueCapabilityResponses, unknown, ThrowOnError>({
            url: '/security/capabilities/{technicianId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Rotates a capability against the caller's observed non-revoked slot. `null` means no slot exists at all; an expired slot still has a fingerprint and must be supplied to prevent a stale manager from silently overwriting it.
     */
    public static putRmmCryptoReplaceCapability<ThrowOnError extends boolean = false>(options: Options<PutRmmCryptoReplaceCapabilityData, ThrowOnError>): RequestResult<PutRmmCryptoReplaceCapabilityResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutRmmCryptoReplaceCapabilityResponses, unknown, ThrowOnError>({
            url: '/security/capabilities/{technicianId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getRmmCryptoCapabilityPolicy<ThrowOnError extends boolean = false>(options: Options<GetRmmCryptoCapabilityPolicyData, ThrowOnError>): RequestResult<GetRmmCryptoCapabilityPolicyResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetRmmCryptoCapabilityPolicyResponses, unknown, ThrowOnError>({ url: '/security/capabilities/account/{accountId}/policy', ...options });
    }
    
    public static putRmmCryptoUpdateCapabilityPolicy<ThrowOnError extends boolean = false>(options: Options<PutRmmCryptoUpdateCapabilityPolicyData, ThrowOnError>): RequestResult<PutRmmCryptoUpdateCapabilityPolicyResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutRmmCryptoUpdateCapabilityPolicyResponses, unknown, ThrowOnError>({
            url: '/security/capabilities/account/{accountId}/policy',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postRmmCryptoIssueCapabilityForAccount<ThrowOnError extends boolean = false>(options: Options<PostRmmCryptoIssueCapabilityForAccountData, ThrowOnError>): RequestResult<PostRmmCryptoIssueCapabilityForAccountResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostRmmCryptoIssueCapabilityForAccountResponses, unknown, ThrowOnError>({
            url: '/security/capabilities/account/{accountId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class RmmScriptsApi {
    public static getScriptsList<ThrowOnError extends boolean = false>(options?: Options<GetScriptsListData, ThrowOnError>): RequestResult<GetScriptsListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetScriptsListResponses, unknown, ThrowOnError>({ url: '/scripts', ...options });
    }
    
    public static postScriptsPublish<ThrowOnError extends boolean = false>(options: Options<PostScriptsPublishData, ThrowOnError>): RequestResult<PostScriptsPublishResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostScriptsPublishResponses, unknown, ThrowOnError>({
            url: '/scripts',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getScriptsListCategories<ThrowOnError extends boolean = false>(options?: Options<GetScriptsListCategoriesData, ThrowOnError>): RequestResult<GetScriptsListCategoriesResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetScriptsListCategoriesResponses, unknown, ThrowOnError>({ url: '/scripts/categories', ...options });
    }
    
    public static postScriptsCreateCategory<ThrowOnError extends boolean = false>(options: Options<PostScriptsCreateCategoryData, ThrowOnError>): RequestResult<PostScriptsCreateCategoryResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostScriptsCreateCategoryResponses, unknown, ThrowOnError>({
            url: '/scripts/categories',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteScriptsDeleteCategory<ThrowOnError extends boolean = false>(options: Options<DeleteScriptsDeleteCategoryData, ThrowOnError>): RequestResult<DeleteScriptsDeleteCategoryResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteScriptsDeleteCategoryResponses, unknown, ThrowOnError>({ url: '/scripts/categories/{categoryId}', ...options });
    }
    
    public static deleteScriptsRemove<ThrowOnError extends boolean = false>(options: Options<DeleteScriptsRemoveData, ThrowOnError>): RequestResult<DeleteScriptsRemoveResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteScriptsRemoveResponses, unknown, ThrowOnError>({ url: '/scripts/{scriptId}', ...options });
    }
    
    public static getScriptsGet<ThrowOnError extends boolean = false>(options: Options<GetScriptsGetData, ThrowOnError>): RequestResult<GetScriptsGetResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetScriptsGetResponses, unknown, ThrowOnError>({ url: '/scripts/{scriptId}', ...options });
    }
    
    public static putScriptsUpdate<ThrowOnError extends boolean = false>(options: Options<PutScriptsUpdateData, ThrowOnError>): RequestResult<PutScriptsUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutScriptsUpdateResponses, unknown, ThrowOnError>({
            url: '/scripts/{scriptId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postScriptsRevoke<ThrowOnError extends boolean = false>(options: Options<PostScriptsRevokeData, ThrowOnError>): RequestResult<PostScriptsRevokeResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostScriptsRevokeResponses, unknown, ThrowOnError>({ url: '/scripts/{scriptId}/revoke', ...options });
    }
}

export class RmmShareGrantsApi {
    public static getShareGrantsGetShareGrant<ThrowOnError extends boolean = false>(options: Options<GetShareGrantsGetShareGrantData, ThrowOnError>): RequestResult<GetShareGrantsGetShareGrantResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetShareGrantsGetShareGrantResponses, unknown, ThrowOnError>({ url: '/share/{grantId}', ...options });
    }
}

export class RmmTagsApi {
    public static getTagsList<ThrowOnError extends boolean = false>(options?: Options<GetTagsListData, ThrowOnError>): RequestResult<GetTagsListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetTagsListResponses, unknown, ThrowOnError>({ url: '/tags', ...options });
    }
    
    public static postTagsCreate<ThrowOnError extends boolean = false>(options: Options<PostTagsCreateData, ThrowOnError>): RequestResult<PostTagsCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostTagsCreateResponses, unknown, ThrowOnError>({
            url: '/tags',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteTagsDelete<ThrowOnError extends boolean = false>(options: Options<DeleteTagsDeleteData, ThrowOnError>): RequestResult<DeleteTagsDeleteResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteTagsDeleteResponses, unknown, ThrowOnError>({ url: '/tags/{tagId}', ...options });
    }
    
    public static putTagsUpdate<ThrowOnError extends boolean = false>(options: Options<PutTagsUpdateData, ThrowOnError>): RequestResult<PutTagsUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutTagsUpdateResponses, unknown, ThrowOnError>({
            url: '/tags/{tagId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class RmmTechniciansApi {
    public static getTechniciansList<ThrowOnError extends boolean = false>(options?: Options<GetTechniciansListData, ThrowOnError>): RequestResult<GetTechniciansListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetTechniciansListResponses, unknown, ThrowOnError>({ url: '/technicians', ...options });
    }
    
    /**
     * Authority workers use this bounded, cross-tenant-only read model to create certificate renewal requests and sign capability replacements. It intentionally returns signing public material and fingerprints, but never certificate/capability bytes or any authority key material.
     */
    public static getTechniciansRenewalCandidates<ThrowOnError extends boolean = false>(options?: Options<GetTechniciansRenewalCandidatesData, ThrowOnError>): RequestResult<GetTechniciansRenewalCandidatesResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetTechniciansRenewalCandidatesResponses, unknown, ThrowOnError>({ url: '/technicians/renewal-candidates', ...options });
    }
    
    public static postTechniciansCredentialReady<ThrowOnError extends boolean = false>(options?: Options<PostTechniciansCredentialReadyData, ThrowOnError>): RequestResult<PostTechniciansCredentialReadyResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<PostTechniciansCredentialReadyResponses, unknown, ThrowOnError>({ url: '/technicians/credential-ready', ...options });
    }
    
    public static postTechniciansRequestEnrollment<ThrowOnError extends boolean = false>(options: Options<PostTechniciansRequestEnrollmentData, ThrowOnError>): RequestResult<PostTechniciansRequestEnrollmentResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostTechniciansRequestEnrollmentResponses, unknown, ThrowOnError>({
            url: '/technicians/request',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteTechniciansRemove<ThrowOnError extends boolean = false>(options: Options<DeleteTechniciansRemoveData, ThrowOnError>): RequestResult<DeleteTechniciansRemoveResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteTechniciansRemoveResponses, unknown, ThrowOnError>({ url: '/technicians/{id}', ...options });
    }
    
    public static putTechniciansUpdate<ThrowOnError extends boolean = false>(options: Options<PutTechniciansUpdateData, ThrowOnError>): RequestResult<PutTechniciansUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutTechniciansUpdateResponses, unknown, ThrowOnError>({
            url: '/technicians/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postTechniciansCreateSrpcToken<ThrowOnError extends boolean = false>(options?: Options<PostTechniciansCreateSrpcTokenData, ThrowOnError>): RequestResult<PostTechniciansCreateSrpcTokenResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<PostTechniciansCreateSrpcTokenResponses, unknown, ThrowOnError>({ url: '/technicians/srpc-token', ...options });
    }
}

export class RmmUpgradesApi {
    public static getUpgradesList<ThrowOnError extends boolean = false>(options?: Options<GetUpgradesListData, ThrowOnError>): RequestResult<GetUpgradesListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetUpgradesListResponses, unknown, ThrowOnError>({ url: '/upgrades', ...options });
    }
    
    public static postUpgradesQueue<ThrowOnError extends boolean = false>(options: Options<PostUpgradesQueueData, ThrowOnError>): RequestResult<PostUpgradesQueueResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostUpgradesQueueResponses, unknown, ThrowOnError>({
            url: '/upgrades',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteUpgradesCancel<ThrowOnError extends boolean = false>(options: Options<DeleteUpgradesCancelData, ThrowOnError>): RequestResult<DeleteUpgradesCancelResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteUpgradesCancelResponses, unknown, ThrowOnError>({ url: '/upgrades/{operationId}', ...options });
    }
    
    public static getUpgradesGet<ThrowOnError extends boolean = false>(options: Options<GetUpgradesGetData, ThrowOnError>): RequestResult<GetUpgradesGetResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetUpgradesGetResponses, unknown, ThrowOnError>({ url: '/upgrades/{operationId}', ...options });
    }
    
    public static getUpgradesListExecutions<ThrowOnError extends boolean = false>(options: Options<GetUpgradesListExecutionsData, ThrowOnError>): RequestResult<GetUpgradesListExecutionsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetUpgradesListExecutionsResponses, unknown, ThrowOnError>({ url: '/upgrades/{operationId}/executions', ...options });
    }
}

export class RmmZynoRpcApi {
    public static postZynoRpcDispatch<ThrowOnError extends boolean = false>(options: Options<PostZynoRpcDispatchData, ThrowOnError>): RequestResult<PostZynoRpcDispatchResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostZynoRpcDispatchResponses, unknown, ThrowOnError>({ url: '/zrpc/{svc}/{method}', ...options });
    }
}
